module.exports = __webpack_public_path__ + "media/images/menu/m3-2c805c6b0ede7d5a029aa263c82e2646.JPG";